import { ListProps } from 'react-admin';
import { Button, Typography } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import { useState } from 'react';
import axiosForApi from '../../config/axios-for-api';
import ReactJson from 'react-json-view';
import { handleError } from '../../functions/common';

const TestSap = ({id}: ListProps & { id: string | null }) => {
    const [vkorg, setVkorg] = useState<string>();
    const [forceVkorg, setForceVkorg] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<Record<string, unknown>>();
    const [error, setError] = useState<string>();

    const handleTestSap = async () => {
        try {
            setData(undefined);
            setError(undefined);
            setLoading(true);
            const {data} = await axiosForApi.post('/api/admin/users/test-sap', {
                user_id: id,
                vkorg: vkorg,
            });
            setData(data);
        } catch (e) {
            setError(handleError(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{padding: '2rem'}}>
            <Typography variant="h6">Test SAP for user #{id}</Typography>
            {error && <div style={{marginTop: '2rem', padding: '0.5rem', color: 'white', backgroundColor: '#c00', borderRadius: '0.5rem'}}>{error}</div>}
            {(loading || data) && <div style={{marginTop: '2rem', padding: '0.5rem', borderRadius: '0.5rem', overflow: 'hidden', backgroundColor:'#333'}}>
                {data && <ReactJson
                    src={data}
                    theme="monokai"
                    collapsed={1}
                    onEdit={false}
                    onDelete={false}
                    onAdd={false}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    enableClipboard={false}/>
                }
                {loading && <span style={{color:'white'}}>Loading ...</span>}
            </div>}
            <div style={{marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '2rem'}}>
                {forceVkorg && <div style={{display: 'flex', flexDirection: 'column', width: '100%', gap: '1rem'}}>
                    <label htmlFor="vkorg">FORCE VKORG</label>
                    <Input id="vkorg" onChange={(e) => setVkorg(e.target.value)} placeholder="Eg. 2000"/>
                </div>}
                <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                    <Button disabled={loading} variant="contained" color="primary" type="button" onClick={handleTestSap}>{loading ? 'Testing ...' : 'Test'} </Button>
                    <Button disabled={loading} variant="contained" color="secondary" type="button" onClick={() => setForceVkorg(true)}>Set VKORG</Button>
                </div>
            </div>
        </div>
    );
};

export default TestSap;
